var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1349 9.13248C26.843 8.04826 25.9881 7.19339 24.9039 6.90149C22.9231 6.35938 14.9999 6.35938 14.9999 6.35938C14.9999 6.35938 7.07679 6.35938 5.096 6.88064C4.03263 7.17254 3.15692 8.04826 2.86501 9.13248C2.34375 11.1133 2.34375 15.2208 2.34375 15.2208C2.34375 15.2208 2.34375 19.3492 2.86501 21.3091C3.15692 22.3933 4.01178 23.2482 5.096 23.5401C7.09764 24.0822 14.9999 24.0822 14.9999 24.0822C14.9999 24.0822 22.9231 24.0822 24.9039 23.561C25.9881 23.2691 26.843 22.4142 27.1349 21.33C27.6561 19.3492 27.6561 15.2416 27.6561 15.2416C27.6561 15.2416 27.677 11.1133 27.1349 9.13248Z",
    fill: "#4B4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4766 18.8708L19.0653 15.076L12.4766 11.2812V18.8708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.fca0b5e3428e686b0be4cd4fece7ba4e.svg";
export { ForwardRef as ReactComponent };